// Which tools the homepage picks menu shows.
//
// Its own module (not beside PicksMenu) so it can be unit-tested by calling it,
// and because a file exporting both components and plain functions breaks React
// Fast Refresh under this repo's eslint config.

import type { RbToolRow } from "@/lib/rbTools";

/**
 * EXACTLY the day's schedule from /manage/tools — nothing else, ever.
 *
 * ⚠️ NO FILLER UNDER A CURATION (owner, 2026-09-13). This used to take the
 * featured tools and pad the row to six with the top of the lineup, so a day
 * with two scheduled picks showed six buttons.
 *
 * ⚠️ AND NO "POPULAR TOOLS" ON AN EMPTY DAY (owner, same day): "I don't
 * understand popular… I just need to be able to assign tool by the day." An
 * unscheduled day used to show the first six of the standing lineup under a
 * "Popular tools" label — buttons that appeared on no day at /manage/tools. A
 * day with no picks now has no gold bar (PicksMenu renders nothing).
 */
export function selectPicks(tools: RbToolRow[]): { picks: RbToolRow[]; curated: boolean } {
  const picks = tools.filter((t) => t.featured);
  return { picks, curated: picks.length > 0 };
}
